import * as React from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axios from "axios";
import { useState } from "react";
import "./CommonDashboard.css";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import EditLocationForm from "./EditLocationForm";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";

import { Button } from "@mui/material";

import { CssBaseline } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { setLocation } from "../redux/slices/locationSlice";

import ConfirmationDialog from "./ConfirmationDialog";
import { setGlobalConfig } from "../redux/slices/globalconfigurations.slice";
import TableStatus from "./TableStatus";

const theme = createMuiTheme({
  spacing: 5,
});

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "rgba(0, 0, 0, 0.87)",
      width: "100%",
      letterSpacing: "0.01071em",
    },
    "& .MuiDataGrid-cell--textLeft": {
      textAlign: "left",
    },
    "& .MuiDataGrid-cell--textCenter": {
      textAlign: "center",
    },
    "& .MuiDataGrid-cell--textRight": {
      textAlign: "right",
    },
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#fafafa",
      width: "100%",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
  },
  table: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),

    width: "100%",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "relative ",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    alignItems: "center",
    marginTop: "10%",
    borderRadius: "5px",
  },
}));

const Configurations = ({ selectedOption, responseData, errors, isLoading }) => {
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const globalConfigData = useSelector((state) => state.globalconfigurations);
  const headersValue = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);

  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const columns = [
    {
      field: "GlobalConfigurationName",
      headerName: "Name",
      flex: 1.2,
      minWidth: 100,
    },
    {
      field: "GlobalConfigurationValue",
      headerName: "Value",
      flex: 1.2,
      minWidth: 100,
    },

    {
      field: "delete",
      headerName: "Delete",
      flex: 1.2,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          variant="outlined"
          startIcon={<DeleteIcon />}
          color="error"
          onClick={() => handleDelete(params?.row?.id)}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      ),
    },
  ];

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setShowConfirmationDialog(true);
  };

  const handleConfirmDelete = () => {
    setShowConfirmationDialog(false);
    setLoading(true);
    const requestBody = {
      path: "globalconfigurations",
      query: { id: `${deleteItemId}` },
      emmsId: selectedOption,
      body: {},
      requestType: "DELETE",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    const headers = headersValue;

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then(() => {
        setRows((prevRows) => {
          const updatedRows = prevRows?.filter(
            (row) => row?.id !== deleteItemId
          );
          dispatch(setGlobalConfig(updatedRows));
          return updatedRows;
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    setShowConfirmationDialog(false);
  };

  React.useEffect(() => {
    if (globalConfigData?.globalconfigurations)
      setRows(globalConfigData?.globalconfigurations);
  }, [globalConfigData?.globalconfigurations]);

  return (
    <>
      {rows?.length > 0 && errors === false ? (
        <CssBaseline>
          <ThemeProvider>
            <div className="emms-data-grid-container" style={{ padding: "2.5% 10%", overflowX: "auto" }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>

            {showConfirmationDialog && (
              <ConfirmationDialog
                open={showConfirmationDialog}
                onClose={handleCancelDelete}
                onConfirm={handleConfirmDelete}
              />
            )}
          </ThemeProvider>
        </CssBaseline>
      ) : (
        <TableStatus loading={isLoading} errors={errors} />
      )}
    </>
  );
};

export default Configurations;
